export const driver = {
  driverName: "Driver Name",
  authorizedVehicles: "Authorized Vehicles",
  certExpireTime: "License Valid Until",
  faceID: "Face ID ",
  faceIDPhoto: "Face ID Photo",
  nfcCardId: "NFC Card ID",
  workXConnectAppCloudUserAccess: "CWorkX Connect App Cloud User Access",
  permitted: "Permitted",
  certPhoto: "Driver License",
  driverPhoto: "Driver Photo",
};
